<template>
    <div class="specialAdd">
        <el-breadcrumb class="bread-nav" separator="/">
            <el-breadcrumb-item>首页</el-breadcrumb-item>
            <el-breadcrumb-item>商业专题</el-breadcrumb-item>
            <el-breadcrumb-item>添加专题</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="special-add-box">
            <el-form :model="addSpecialForm" :rules="validateRules" ref="addSpecialForm" label-width="100px" class="addSpecialForm">
                <el-form-item label="标题" prop="specialName">
                    <el-input v-model="addSpecialForm.specialName" placeholder="请填写专题标题"></el-input>
                </el-form-item>
                <el-form-item label="所属大区" prop="company">
                    <el-select class="selectForm" v-model="addSpecialForm.company" placeholder="请选择大区">
                        <el-option v-for="companyItem in companyList" :key="companyItem" :label="companyItem" :value="companyItem"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="头图" prop="specialImage">
                    <el-input v-model="addSpecialForm.specialImage" placeholder="请填写专题头图"></el-input>
                </el-form-item>
                <el-form-item label="概述" prop="specialContent">
                    <el-input type="textarea" v-model="addSpecialForm.specialContent" placeholder="请填写专题概述"></el-input>
                </el-form-item>
                <el-form-item label="项目经理" prop="createUser">
                    <el-select class="selectForm" v-model="addSpecialForm.createUser" placeholder="请选择项目经理">
                        <el-option v-for="userItem in userList" :key="userItem.userId" :label="userItem.userName" :value="userItem.userId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="addSpecial('addSpecialForm')">立即创建</el-button>
                    <el-button @click="clearSpecialData()">重置</el-button>
                </el-form-item>
            </el-form>
            <div class="special-preview-box">
                <div class="header-image" v-if="addSpecialForm.specialImage !== null && addSpecialForm.specialImage !== ''">
                    <img :src="addSpecialForm.specialImage" alt="一点资讯">
                </div>
                <div class="description" v-if="addSpecialForm.specialContent !== null && addSpecialForm.specialContent !== ''">
                    <div class="desc-icon">概述</div>
                    <span class="desc-content">{{addSpecialForm.specialContent}}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import CONFIG from "@/config/index.js";
import TOOL from '@/tool/index.js';
import router from "@/router/index.js";
import { mapGetters } from 'vuex';
export default {
    name: "specialAdd",
    data() {
        return {
            addSpecialForm: {
                specialName: null,
                company: null,
                createUser: null,
                specialImage: null,
                specialContent: null
            },
            companyList: [
                '华北',
                '华东',
                '华南',
                '本地化事业部',
                '汽车事业部',
                '全国营销中心',
                '效果广告营销中心'
            ],
            userList: null,
            validateRules: {
                specialName: [
                    { required: true, message: '请填写专题标题', trigger: 'blur' }
                ],
                company: [
                    { required: true, message: '请选择所属大区', trigger: 'change' }
                ],
                createUser: [
                    { required: true, type: 'number', message: '请选择项目经理'}
                ],
                specialImage: [
                    { required: true, message: '请填写专题头图', trigger: 'blur' }
                ],
                specialContent: [
                    { required: true, message: '请填写专题概述', trigger: 'blur' }
                ]
            }
        };
    },
    mounted(){
        this._init();
    },
    methods: {
         _getUserList() {
            this.$http.get(CONFIG.HOST + "/users/list" + '?t=' + TOOL.getCurrentTime()).then((response)=>{
                let result = response.body;
                if (result && result.status === 1) {
                    this.userList = result.data;
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            }, (response)=>{
                console.log(response);
            });
        },
        _confirmMessage(message, success = ()=>{}, cancel = ()=>{}) {
            this.$confirm(message, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(success).catch(cancel);          
        },
        addSpecial(formName){
            let flag = true;
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    flag = false;
                    return false;
                }
            });
            if (!flag) {
                return;
            }
            this.$http.post(CONFIG.HOST + '/special/add', this.addSpecialForm).then((response)=>{
                let result = response.body;
                if (result && result.status === 1) {
                    this.$notify.success({
                        message: '【营销平台】商业专题创建成功'
                    });
                    this.clearSpecialData();
                    router.push({
                        name: 'businessList'
                    });
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            },(response)=>{
                console.log(response);
            });
        },
        clearSpecialData(){
            this.addSpecialForm.specialName = null;
            this.addSpecialForm.company = null;
            this.addSpecialForm.createUser = null;
            this.addSpecialForm.specialImage = null;
            this.addSpecialForm.specialContent = null;
        },
        _init() {
            this._getUserList();
        }
    }
};
</script>
<style lang="less">
    .specialAdd{
        width: 98%;
        margin: 0 auto;
        .bread-nav{
            margin: 20px 0;
        }
        .special-add-box{
            width: 980px;
            position: relative;
            left: 0;
            top: 0;
            .addSpecialForm{
                width: 440px;
                
                position: absolute;
                left: 0;
                top: 0;

                .selectForm{
                    width: 100%;
                }
            }
            .special-preview-box{
                width: 360px;
                height: 540px;
                border: 1px solid #bfcbd9;
                border-radius: 6px;

                position: absolute;
                left: 550px;
                top: 0;

                .header-image{
                    width: 100%;
                    display: block;
                    img{
                        width: 100%;
                    }
                }
                .description{
                    padding: 0 11px;
                    font-size: 10px;
                    text-align: left;
                    .desc-icon{
                        color: #fff;
                        background: #0c9aee;
                        display: inline-flex;
                        padding-left: 2px;
                        padding-right: 2px;
                    }
                    .desc-content{

                    }
                }
            }
        }
    }  
</style>


// WEBPACK FOOTER //
// Add.vue?5302b302